import { render, staticRenderFns } from "./veeva.vue?vue&type=template&id=7cf1b5e5&scoped=true&v-once=true"
import script from "./veeva.vue?vue&type=script&lang=js"
export * from "./veeva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf1b5e5",
  null
  
)

export default component.exports